import { init } from '@sentry/react';

import { SENTRY_DSN, SENTRY_ENVIRONMENT } from './constants/env';

init({
  dsn: SENTRY_DSN,
  environment: SENTRY_ENVIRONMENT,
  enabled: process.env.NODE_ENV === 'production',
  sendDefaultPii: true,
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 0.0, // Adjust sample rate as needed
});
